module.exports = __webpack_public_path__ + "static/media/Basket.aee31094.svg";